module.exports = __webpack_public_path__ + "img/imagen6.2f4dc395.png";